module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit",
    class: {
      active: _vm.page == 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxShow == 1),
      expression: "wxShow==1"
    }],
    staticClass: "tit",
    class: {
      active: _vm.page == 2
    },
    on: {
      "click": function($event) {
        return _vm.changePage(2)
      }
    }
  }, [_vm._v("微信登录")]), _vm._v(" "), _c('p', {
    staticClass: "tit",
    class: {
      active: _vm.page == 3
    },
    on: {
      "click": function($event) {
        return _vm.changePage(3)
      }
    }
  }, [_vm._v("短信登录")])]), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg) + " "), (_vm.errorMsg == '用户名不存在，') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("快速注册？")]) : _vm._e()], 1), _vm._v(" "), (_vm.page == 1) ? _c('div', {
    staticClass: "con-page"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "用户名/手机号/注册邮箱",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pas),
      expression: "pas"
    }],
    staticClass: "pas",
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.pas)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pas = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")])]) : _vm._e(), _vm._v(" "), (_vm.page == 2) ? _c('div', {
    staticClass: "con-page"
  }, [_c('div', {
    staticClass: "ewm"
  }, [(_vm.ewmSrc !== '') ? _c('img', {
    attrs: {
      "src": _vm.ewmSrc,
      "alt": "二维码"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.page == 3) ? _c('div', {
    staticClass: "con-page"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    staticClass: "cal",
    attrs: {
      "type": "text",
      "placeholder": "手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzm),
      expression: "yzm"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "短信验证码",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.yzm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.changeState
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), (_vm.page == 1) ? _c('router-link', {
    staticClass: "res",
    attrs: {
      "to": {
        name: 'findPas'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "login-way"
  }, [_vm._v("使用第三方账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "elLogin"
  }, [_c('a', {
    staticClass: "el1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getQQ
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getWEI
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getBO
    }
  })])])]), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "iframe",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d1f1a7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 105
// module chunks = 1